import React from "react";
import API from '../Utils/api';

export class Validador extends React.Component {
    constructor(props) {
        super(props);
        this.validaPedido();
    }


    async validaPedido() {
        const hash = window.location.href.split('/')[window.location.href.split('/').length - 1];
        try {
            const response1 = await API.get(`/api/app/notification-url/${hash}`);
            console.log(`/api/app/notification-url/${hash}`)
        } catch (err) {
            console.log(err);
        }
    }

    render() {
        return (<span>cartela validada!</span>);
    }


}






export default Validador;
